﻿export class AtlFileUploadEvent extends CustomEvent<{ payload: FileList }> {
    static EVENT_NAME = 'file-upload';

    constructor(files: FileList) {
        super(AtlFileUploadEvent.EVENT_NAME, {
            detail: { payload: files },
            bubbles: true,
            composed: true,
        });
    }
}
